import {JobPositionEN} from "./personnel/job-position/en";
import {PersonnelSettingEN} from "./personnel/en";
import {ApplicationReasonEN} from "./applicaiton/en";
import {TimekeepingSettingEN} from "./timekepping/en";

export const SettingEN = {
    "setting": {
        "title": "Setting",
        "back" : "Back to list",
        "system": {
            "configuration": "Configuration",
            "admin": "Admin",
            "automatic": "Automatic",
            "email": "Email"
        },
        "workplace": {
            "work": "Work",
            "officialDispatch": "Official dispatch",
            "calendar": "Calendar"
        },
        "hrm": {
            "application": "Application",
            "asset": "Asset",
            "recruitment": "Recruitment",
            "personnel": "Personnel",
            "timekeeping": "Timekeeping",
        },
        "crm": {
            "customerService": "Customer service",
            "receiptPayment": "Receipt & Payment",
            "wareHouse": "Warehouse",
            "purchases": "Purchases",
        }
    },
    ...JobPositionEN,
    ...PersonnelSettingEN,
    ...ApplicationReasonEN,
    ...TimekeepingSettingEN,
}